export const MARKET_VALUE = 'marketValue'
export const MARKET_WEIGHT = 'marketWeight'
export const ASSET_NAME = 'assetName'



// WEBPACK FOOTER //
// ./src/utils/Client/holdingsConstants.js